import { useEffect } from 'react';
import * as React from 'react';
import { PAY360_RESULT } from '../../../consts/payment';
import { parse } from 'query-string';
import { getConfig } from '../../../services/public/config';
import { getOrderBySessionId } from '../../../services/public/order';
import { Loader } from '../../../components/Loader/Loader';
import { createBrokenOrder, deleteBrokenOrder, updateBrokenOrder } from '../../../services/public/brokenOrder';

function AllPaymentsSuccessIframe(props) {
  useEffect(() => {
    const { history } = props;
    const search = parse(history.location.search);
    const sessionId = search.sessionId as string;

    let initialTimer = null;
    let maximumTimer = null;
    let timer = null;
    let settled = false;
    const clearTimers = () => {
      clearTimeout(initialTimer);
      clearTimeout(maximumTimer);
      clearInterval(timer);
    };
    const finish = (result: string, cleanup: () => Promise<any>) => {
      if (settled) return;
      settled = true;
      clearTimers();
      const notifyParent = () => window.top.postMessage(result, '*');
      cleanup().then(notifyParent, notifyParent);
    };

    createBrokenOrder(sessionId)
      .then(() => getConfig())
      .then(res => {
        const { payments } = res;
        const { pay360 } = payments;
        const { pay360InitialWaitingTime, pay360MaximumWaitingTime, pay360AdditionalWaitingTime } = pay360;

        maximumTimer = setTimeout(() => {
          finish(PAY360_RESULT.TIMEOUT, () => updateBrokenOrder(sessionId));
        }, pay360MaximumWaitingTime);

        initialTimer = setTimeout(() => {
          getOrderBySessionId(sessionId).then(res => {
            const { orderStatus } = res;
            switch (orderStatus) {
              case PAY360_RESULT.PAID:
                finish(PAY360_RESULT.PAID, () => deleteBrokenOrder(sessionId));
                break;
              case PAY360_RESULT.CANCELED:
                finish(PAY360_RESULT.CANCELED, () => deleteBrokenOrder(sessionId));
                break;
              default: {
                timer = setInterval(() => {
                  getOrderBySessionId(sessionId).then(res => {
                    const { orderStatus } = res;
                    switch (orderStatus) {
                      case PAY360_RESULT.PAID:
                        finish(PAY360_RESULT.PAID, () => deleteBrokenOrder(sessionId));
                        break;
                      case PAY360_RESULT.CANCELED:
                        finish(PAY360_RESULT.CANCELED, () => deleteBrokenOrder(sessionId));
                    }
                  });
                }, pay360AdditionalWaitingTime);
              }
            }
          });
        }, pay360InitialWaitingTime);
      });
    return () => {
      settled = true;
      clearTimers();
    };
  }, []);

  return (
    <div className={'mt-3'}>
      <Loader />
      <div className={'text-center'}>Waiting for payment authorization...</div>
    </div>
  );
}

export default AllPaymentsSuccessIframe;
